import React, { useEffect, useState, useContext } from 'react'
import { HtmlViewer } from '../htmlViewer/HtmlViewer'
import { useParams } from 'react-router-dom'
import { getAviso } from "./avisosController"
import { AuthContext } from '../../context/Authcontext'

export const Avisos = () => {

    const [aviso, setAviso] = useState(null)

    const { avisoId } = useParams()
    const { userInfo } = useContext(AuthContext)

    useEffect(() => {

        const getAvisoFunc = async () =>{

            try{
                const responseAviso = await getAviso(avisoId);

            console.log(responseAviso);
                console.log(userInfo);
            if(responseAviso){

                const nombre = userInfo?.name ?? "";

                responseAviso.htmlContent = responseAviso.htmlContent.replaceAll("#nombre#", userInfo?.name?? "").replaceAll("#apellido#", userInfo?.lastname?? "").replaceAll("#email#", userInfo?.email ?? "");

                setAviso(responseAviso);
            }            
            
            }
            catch(error)
            {

            }

        }

        getAvisoFunc();

    }, [avisoId])

    return (<>
        {aviso?.htmlContent ? <HtmlViewer content={aviso.htmlContent} cssClass='avisos' showReadMore={false} /> : null}
    </>)

}

